<template>
  <canvas
    id="main-canvas"
    :width="width"
    :height="height"
    :style="{'background-color': currentFill, height: canvas_h + 'px'}"
    @touchstart="MouseDown"
    @touchmove.prevent="MoveTouch"
    @mousedown="MouseDown"
    @mousemove="MouseMove"
  >Sorry, your browser doesn't support the &lt;canvas&gt; element.</canvas>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 780 },
    height: { type: Number, default: 642 },
    color: { type: String, default: "rgba(0,0,0,1)" },
    tool: { type: String, default: "brush" },
    radius: { type: Number, default: 4 },
    artist: { type: Boolean, default: true },
    actions: { type: Array, default:[] }
  },
  watch: {
    actions() {
      this.Draw();
    }
  },
  data() {
    return {
      canvas_h: 0,
      lastPoint: { x: Number, y: Number },
      ctx: Object,
      currentFill: "#00000000",
      mouseDown: false,
      draw: false
    };
  },
  beforeMount() {
    this.$nextTick(() => {
      let canvas = document.querySelector("#main-canvas");
      if (canvas.getContext) {
        this.ctx = canvas.getContext("2d");
        this.ctx.strokeStyle = this.color;
        this.ctx.lineWidth = this.radius;
        this.ctx.lineCap = "round";
        this.ctx.lineJoin = "round";
        this.ResizeCanvas();
      }
    });
    window.addEventListener("resize", this.ResizeCanvas);
    document.addEventListener("mouseup", this.MouseUp);
    document.addEventListener("touchend", this.MouseUp);
    document.addEventListener("keydown", this.KeyHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.ResizeCanvas);
    document.removeEventListener("mouseup", this.MouseUp);
    document.removeEventListener("touchend", this.MouseUp);
    document.removeEventListener("keydown", this.KeyHandler);
  },
  methods: {
    ResizeCanvas() {
      let x = this.$el.clientWidth;
      this.canvas_h = x * 0.823;
      this.$emit("resize_canvas", this.canvas_h);
    },
    KeyHandler(e) {
      if (this.artist) {
        if (e.code == "KeyR" || e.keyCode == 46) {
          this.SetClear();
        } else if (e.code == "KeyZ" && e.ctrlKey) {
          this.SetRevert();
        }
      }
    },
    // События холста
    MouseDown(e) {
      if (this.artist && (e.buttons == 1 || e.type == "touchstart")) {
        if (this.tool == "fill") this.SetFiil(this.color);
        else this.mouseDown = true;
      }
    },
    MouseUp(e) {
      if (!this.draw && this.mouseDown) {
        let c = this.ConvertCords(e);
        this.SetCircle(c.x, c.y);
      }
      this.draw = false;
      this.mouseDown = false;
    },
    MoveTouch(e) {
      this.MouseMove(e.changedTouches[0]);
    },
    MouseMove(e) {
      if (this.mouseDown) {
        let c = this.ConvertCords(e);
        this.SetPath(c.x, c.y);
      }
    },
    // ------------------------------

    // Конвертер координат
    ConvertCords(e) {
      let x = e.pageX - e.target.offsetParent.offsetParent.offsetLeft;
      let y = e.pageY - e.target.offsetParent.offsetParent.offsetTop;
      let rx = this.width / this.$el.clientWidth;
      let ry = this.height / this.$el.clientHeight;
      return {
        x: Math.round(x * rx),
        y: Math.round(y * ry)
      };
    },
    // Установка значений в массив
    // Точка
    SetCircle(x, y) {
      let color = this.tool == "erase" ? "erase" : this.color;
      this.$emit("new_draw", `A DP ${color} ${this.radius} ${x} ${y} `);
    },
    // Путь
    SetPath(x, y) {
      if (this.draw) {
        this.$emit("old_draw", `${x} ${y} `);
      } else {
        let color = this.tool == "erase" ? "erase" : this.color;
        this.lastPoint.x = x;
        this.lastPoint.y = y;
        this.$emit("new_draw", `A D ${color} ${this.radius} ${x} ${y} `);
        this.draw = true;
      }
    },
    // Очистка
    SetClear() {
      this.$emit("new_draw", "A C ");
    },
    // Отмена
    SetRevert() {
      this.$emit("new_draw", "A Z ");
    },
    SetFiil(color) {
      this.$emit("new_draw", `A F ${color} `);
    },
    // ---------------------------------------

    // ОТРИСОВКА
    // фильтрация перед отрисовкой
    FilterArray() {
      let arr = [];
      let zCount = 0;
      if (this.actions.length > 1) {
        for (let i = this.actions.length - 1; i > -1; i--) {
          // if (actions[i].split(" ")[1] == "C") break;
          if (this.actions[i].split(" ")[1] == "Z") {
            zCount++;
            continue;
          }
          if (zCount > 0) {
            i -= zCount - 1;
            zCount = 0;
            continue;
          }
          arr.unshift(this.actions[i]);
        }
      } else return this.actions;
      return arr;
    },
    // Коммутатор отрисовки
    Draw() {
      this.Clear();
      let arr = this.FilterArray();
      arr.forEach(element => {
        let action = element.split(" ")[1];
        switch (action) {
          case "DP": {
            let c = element.split(" ")[2];
            let r = element.split(" ")[3];
            let x = element.split(" ")[4];
            let y = element.split(" ")[5];
            this.DrawPoint(x, y, c, r);
            break;
          }
          case "D": {
            let c = element.split(" ")[2];
            let r = element.split(" ")[3];
            let array = element.split(" ");
            for (let i = 4; i < array.length; i += 2) {
              if (i == 4) this.DrawPath(true, array[i], array[i + 1], c, r);
              else this.DrawPath(false, array[i], array[i + 1], c, r);
            }
            this.ctx.stroke();
            break;
          }
          case "C":
            this.Clear();
            break;
          case "F":
            let c = element.split(" ")[2];
            this.FillCanvas(c);
            break;
        }
      });
    },
    // Устанавливает размер, цвет и тип рисования (стерка/краска)
    SetSettingDraw(color, radius) {
      let isErase = color == "erase";
      this.ctx.lineWidth = radius;
      if (isErase) {
        this.ctx.strokeStyle = "rgba(255,255,255,1)";
        this.ctx.globalCompositeOperation = "destination-out";
      } else {
        this.ctx.strokeStyle = color;
        this.ctx.globalCompositeOperation = "source-over";
      }
    },
    // рисует точку
    DrawPoint(x, y, color, radius) {
      this.SetSettingDraw(color, radius);
      this.ctx.beginPath();
      this.ctx.moveTo(x, y);
      this.ctx.lineTo(x, y);
      this.ctx.stroke();
    },
    // рисует линию
    DrawPath(first, x, y, color, radius) {
      if (first) {
        this.SetSettingDraw(color, radius);
        this.ctx.beginPath();
        this.ctx.moveTo(x, y);
      } else {
        this.ctx.lineTo(x, y);
      }
    },
    // чистит доску
    Clear() {
      this.ctx.clearRect(0, 0, this.width, this.height);
    },
    FillCanvas(color) {
      this.currentFill = color;
    }
  }
};
</script>

<style>
</style>